import React from 'react';
import {DatePicker, Empty, Select, Table} from "antd";
import utils from "../common/utils";
import {Translation} from "react-i18next";
import LoadingComponent from "./common/LoadingComponent";
import consts from "../consts";
import moment from 'moment'
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import { isEmpty } from 'lodash';
const { Option } = Select;
const { RangePicker } = DatePicker;
class OrderHistoryComponent extends LoadingComponent {
	columns = (t) => [
		{
			align: "center",
			title: t('user.open_order.id'),
			width: 60,
			dataIndex: 'id',
		},
		{
			align: "center",
			title: t('user.open_order.transfer'),
			width: 80,
			dataIndex: 'trade_type',
			key: 'trade_type',
			render: (type) => <div
				style={{ color: (type === consts.ORDER_TRADE_TYPE_BUY) ? 'green' : 'red' }}>{type === consts.ORDER_TRADE_TYPE_BUY ? t('Buy') : t('Sell')}</div>
		},
		{
			align: "center",
			title: t('user.open_order.order_type'),
			width: 80,
			dataIndex: 'type',
			key: 'type',
			render: (type) => t(utils.parseOrderType(type)),
		},
		{
			align: "center",
			title: t('user.open_order.pair'),
			width: 90,
			dataIndex: 'pair',
			key: 'pair',
		},
		{
			align: "center",
			title: t('user.open_order.withdrawal'),
			width: 100,
			dataIndex: 'price',
			key: 'price',
			render: (price, { currency }) => `${utils.formatCurrency(price)} ${currency}`
		},
		{
			align: "center",
			title: t('user.open_order.coin'),
			width: 120,
			dataIndex: 'quantity',
			key: 'quantity',
			render: (quantity, {coin, executed_quantity}) => (
				<div>{utils.formatCurrency(executed_quantity)} / {utils.formatCurrency(quantity + executed_quantity)} {coin}</div>
			)
		},
		// {
		// 	align: "center",
		// 	title: t('user.open_order.quantity'),
		// 	width: 100,
		// 	dataIndex: 'quantity',
		// 	key: 'quantity',
		// 	render: (quantity) => <div>{utils.formatCurrency(quantity)}</div>
		// },
		{
			align: "center",
			title: t('user.open_order.status'),
			width: 100,
			dataIndex: 'status',
			key: 'status',
			render: (status) => t(utils.parseOrderStatus(status))
		},
		{
			align: "center",
			title: t('user.open_order.created_at'),
			width: 130,
			dataIndex: 'created_at',
			key: 'created_at',
			render: (createdAt) => utils.formatTimeFromUnix(createdAt, "DD/MM/YYYY HH:mm:ss")
		},
	];

	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			currentPage: 1,
			totalCount: 0,
			clsData: [],
			id_trans: ''
		};
		this.filter = {
			pos: 0,
			count: 10,
			coin: '',
			order_type: -1,
			trade_type: -1,
			status: -1,
			start_time: '',
			end_time: '',
		}
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE) => {
		this.enLoading();
		this.filter = {
			...this.filter,
			pos,
			count,
		}
		this.props.onFetchOrdersAction(this.filter, (totalCount) => this.setState({ totalCount },() => this.unLoading()));
	}

	changeTradeType = (trade) => {
		this.filter = {
			...this.filter,
			trade_type: trade,
		}
		this.fetchData()
	}

	changeOrderType = (order) => {
		this.filter = {
			...this.filter,
			order_type: order,
		}
		this.setState({
			currentPage: 1
		})
		this.fetchData()
	}

	changeMarket = (pair) => {
		let str = pair.split("/")
		let coin = str[0]
		let currency = str[1]
		this.filter = {
			...this.filter,
			coin,
			currency,
		}
		this.setState({
			currentPage: 1
		})
		this.fetchData()
	}

	changeOrderStatus = (status) => {
		this.filter = {
			...this.filter,
			status: status,
		}
		this.setState({
			currentPage: 1
		})
		this.fetchData()
	}

	onChangeDate = (date) => {
		if(!!date){
			this.filter = {
				...this.filter,
				start_time: date[0].startOf('day').unix(),
				end_time: date[1].endOf('day').unix(),
			}
		}
		else{
			this.filter = {
				...this.filter,
				start_time: '',
				end_time: '',
			}
		}
		this.fetchData()
	}

	collapseColumns = (t) => [
		{
			align: "center",
			title: t('user.open_order.order_type'),
			width: 100,
			dataIndex: 'transaction_type',
			key: 'transaction_type',
			render: (type) => <div
				style={{ color: (type === consts.ORDER_TRADE_TYPE_BUY) ? 'green' : 'red' }}>{type === consts.ORDER_TRADE_TYPE_BUY ? t('Buy') : t('Sell')}</div>
		},
		{
			align: "center",
			title: t('user.order_trans.id'),
			width: 60,
			dataIndex: 'id',
			key: 'id',
		},
		{
			align: "center",
			title: t('user.open_order.withdrawal'),
			width: 100,
			dataIndex: 'price',
			key: 'price',
			render: (price, { currency }) => `${utils.formatCurrency(price)} ${currency}`
		},
		{
			align: "center",
			title: t('user.open_order.coin'),
			width: 100,
			dataIndex: 'quantity',
			key: 'quantity',
			render: (quantity, { coin }) => <div title={quantity}>{utils.formatCurrency(quantity)} {coin}</div>,
		},
		{
			align: "center",
			title: t('user.open_order.created_at'),
			width: 150,
			dataIndex: 'created_at',
			key: 'created_at',
		},
	]

	UNSAFE_componentWillReceiveProps(nextProps){
		if(this.props.idOrderTransactions !== nextProps.idOrderTransactions){
			let newObj = new Object()
			newObj[this.state.id_trans] = nextProps.idOrderTransactions
			this.setState({
				clsData:  {
					...this.state.clsData,
					...newObj,
				},
			})
		}
	}


	collapseTable = (record, t) =>  {
		return (
			<div className="p-medium">
				<Table
				key={record.id}
				columns={this.collapseColumns(t)}
				dataSource={this.state.clsData[record.id]}
				pagination={{
					hideOnSinglePage: true,
				}}
				
			/>
			</div>
		)
	}
	
	

	render() {
		return (
			<Translation>
				{(t) => <div className="depositandwithdrawal user-wallet">
					{/*<h1 className="text-white text-left">{t('user.order.title')}</h1>*/}
					<div className="depositandwithdrawal-top">
						<div className='coin-container'>
							<div className='control'>
								<span className='label'> {t('user.open_order.transfer')} </span>
								<Select defaultValue="-1" style={{ width: 120 }} className='coinSelect' onChange={this.changeTradeType}>
									<Option value="-1"> {t('user.deposit_and_withdrawal.all')} </Option>
									<Option value="0">{t('user.open_order.buy')} </Option>
									<Option value="1"> {t("user.open_order.sell")} </Option>
								</Select>
							</div>
							<div className='control'>
								<span className='label'> {t('user.open_order.order_type')} </span>
								<Select defaultValue="-1" style={{ width: 120 }} className='coinSelect' onChange={this.changeOrderType}>
									<Option value="-1"> {t('user.deposit_and_withdrawal.all')} </Option>
									<Option value="0"> {t('user.open_order.limit')} </Option>
									<Option value="1"> {t('user.open_order.market')} </Option>
									<Option value="2"> {t('user.open_order.stop_limit')}</Option>
								</Select>
							</div>
							<div className='control'>
								<span className='label'> {t('user.open_order.pair')} </span>
								<Select defaultValue="" style={{ width: 120 }} className='coinSelect' onChange={this.changeMarket}>
									<Option value=""> {t('user.deposit_and_withdrawal.all')} </Option>
									{window._.map((this.props.setting?.coinSettings || []), (item) => {
										return <Option key={item.pair}>
											<div className="ln-big">
												{item.pair}
											</div>
										</Option>
									})}
								</Select>
							</div>
							<div className='control'>
								<span className='label'> {t('user.open_order.status')} </span>
								<Select defaultValue="-1" style={{ width: 120 }} className='coinSelect' onChange={this.changeOrderStatus}>
									<Option value="-1"> {t('user.deposit_and_withdrawal.all')} </Option>
									<Option value="0"> {t('Stopping')} </Option>
									<Option value="1"> {t('Pending')} </Option>
									<Option value="2"> {t('Executed')}</Option>
									<Option value="3"> {t('Cancel')}</Option>
									<Option value="4"> {t('Executing')}</Option>
								</Select>
							</div>
							<div className='control'>
								<span className='label'> {t('user.deposit_and_withdrawal.deposit_and_withdrawal_date')} </span>
								<RangePicker className="date-picker1" format={'DD/MM/YYYY'}
								separator={<HiOutlineArrowNarrowRight style={{fontSize: 11, marginRight: 10, color: 'rgba(0, 0, 0, 0.25)'}}/>}
									disabledDate={(current) => current && current > moment().endOf('day')}
									placeholder={[
										t('user.deposit_and_withdrawal.deposit_and_withdrawal_start_date'),
										t('user.deposit_and_withdrawal.deposit_and_withdrawal_end_date')
									]}
									onChange={this.onChangeDate}
								/>
							</div>
						</div>
					</div>
					<div className="depositandwithdrawal-top">
						<Table columns={this.columns(t)}
							// scroll={{ y: '65vh' }}
							locale={{ emptyText: (<Empty description={<span className="bold">{window.$t('common.empty')}</span>} />) }}
							rowClassName="pointer"
							expandable={{
								expandedRowRender: (record) => this.collapseTable(record, t),
								// expandedRowRender: (record) => <span>{record.coin}</span>,
								expandRowByClick: true,
								rowExpandable: record =>  !isEmpty(record.sub_ids),
								onExpand: (expanded, record) => (
									expanded ?
									(
										this.setState({id_trans: record.id}),
										this.props.onFetchIdOrderTrans(record.id)
									)
									: ""),
							}}
							pagination={{
								showQuickJumper: true,
								current: this.state.currentPage,
								onChange: (page, pageSize) => {
									this.setState({currentPage: page})
									this.enLoading();
									this.fetchData((page - 1) * pageSize, pageSize)
								},
								defaultPageSize: 10,
								total: this.state.totalCount,
								hideOnSinglePage: true,
							}}
							dataSource={[...this.props.order.orders || []]}
							loading={this.state.isLoading}
							className="mb-large"
						/>
					</div>
				</div>}
			</Translation>
		);
	}
}

export default OrderHistoryComponent;
